export default __webpack_public_path__ + "static/step-3-6e1a8337b0cb1f2148c81d4ee0cab167.gif";